
import * as React from 'react';
import { cn } from '@/lib/utils';

export function Card({
  asChild = false,
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { asChild?: boolean }) {
  const classes = cn('rounded-card border border-border bg-card', className);

  if (asChild && React.isValidElement(children)) {
    const child = children as React.ReactElement<{ className?: string }>;
    return React.cloneElement(child, {
      ...props,
      className: cn(classes, child.props.className),
    });
  }

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
}
